import { EAlignFieldType } from '@/dealroom/fields/context-menu/types/enums/align-field-type';
import { IFieldAlignOption } from '@/dealroom/fields/context-menu/types/field-align-option';

export const fieldAlignOptions: IFieldAlignOption[] = [
  {
    icon: 'align-left',
    text: 'left',
    actionType: EAlignFieldType.Left,
  },
  {
    icon: 'align-right',
    text: 'right',
    actionType: EAlignFieldType.Right,
  },
  {
    icon: 'align-top',
    text: 'top',
    actionType: EAlignFieldType.Top,
  },
  {
    icon: 'align-bottom',
    text: 'bottom',
    actionType: EAlignFieldType.Bottom,
  },
  {
    icon: 'same-width',
    text: 'same-width',
    actionType: EAlignFieldType.SameWidth,
  },
];
